module.exports = __webpack_public_path__ + "static/media/img2.8273deed.jpg";